import { actions } from '../../utils/constants';

export const createTrainer = (trainer) => ({
    type: actions.ASYNC_CREATE_TRAINER,
    payload: trainer,
});

export const deleteTrainer = (userId) => ({
    type: actions.ASYNC_DELETE_TRAINER,
    payload: { userId },
});

export const fetchTrainers = () => ({
    type: actions.ASYNC_FETCH_TRAINERS,
});



// WEBPACK FOOTER //
// ./src/components/trainers/trainers.actions.js